import React from "react";
import FormControlProps from "./FormControl.types";
import * as S from "./FormControl.styles";

/**
 * BW FormControl component.
 */
const FormControl: React.FC<FormControlProps> = ({ children, as, ...rest }) => (
    <S.FormControl role="group" as={as} {...rest}>
        {children}
    </S.FormControl>
);

FormControl.defaultProps = {
    as: "fieldset"
};

export default FormControl;
